import React from 'react';
import HeroSectionParceiros from '../components/HeroSectionParceiros';
import VisibilidadeAgendamentosSection from '../components/VisibilidadeAgendamentosSection';
import TicketMedioSection from '../components/TicketMedioSection';
import AgendaGestaoSection from '../components/AgendaGestaoSection';
import ResultadosParceirosSection from '../components/ResultadosParceirosSection';
import PerguntasFrequentesParceirosSection from '../components/PerguntasFrequentesParceirosSection';

export function ParceirosPage() {
  return (
    <div className="parceiros-page">
      <HeroSectionParceiros />
      <VisibilidadeAgendamentosSection />
      <TicketMedioSection />
      <AgendaGestaoSection />
      <ResultadosParceirosSection />
      <PerguntasFrequentesParceirosSection />
    </div>
  );
};

